if (!window.customElements.get('featured-collections')) {
  class FeaturedCollections extends HTMLElement {
    constructor() {
      super();
      this.items = this.dataset.items;
      this.mobileItems = this.dataset.mobileItems || 1.3;
      this.swiper = this.querySelector('.swiper');
      this.initSlider();
    }

    selectors = {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    }

    initSlider() {
      this.sliderOptions = {
          slidesPerView: parseFloat(this.mobileItems),
          spaceBetween: 16,
          navigation: {
            nextEl: this.querySelector(this.selectors.nextEl),
            prevEl: this.querySelector(this.selectors.prevEl),
          },
          pagination: {
            el: ".swiper-pagination",
            type: "progressbar",
          },
          breakpoints: {
            769: {
              slidesPerView: 3.3,
            },
            1280: {
              slidesPerView: parseFloat(this.items),
            },
          },
          loop: false,
          threshold: 2,
        };
      
      this.slider = new Swiper(this.swiper, this.sliderOptions);
      this.style.opacity = '1';
    }
  }
  window.customElements.define('featured-collections', FeaturedCollections);
}
